<template>
  <section class="object-info-box">
    <div class="card object-info">
      <div class="widgets-panel__header"  v-if="zone_info.info">
        <div class="widgets-panel__tracker-group"
             v-if="zone_info.info.CustomType && zone_info.info.CustomType.length > 0 ">{{ zone_info.info.CustomType }}
        </div>
        <div class="widgets-panel__tracker-title">
          <div v-if="checkObjectLength(zone_info) ">{{ zone_info.info.Name }}</div>


          <button type="button" class="btn object-info-close" @click="closeInfo()"><span class=" fa fa-times"></span>
          </button>

        </div>
        <div class="street-view widgets-panel__street-view">
          <div class="street-view__streetview" :style="{ backgroundImage: 'url(' + backgroundImageUrl + ')' }">


          </div>
          <div class="street-view__click-stub">
            <span aria-hidden="true" class="fa touch-icon">
          <svg-click-icon></svg-click-icon>
          </span>
            <translate-component :text="lang.zone_info_component.view_panoramas"></translate-component>
          </div>
        </div>
      </div>
      <template v-if="checkObjectLength(zone_info)">
        <div class="card-body">
        </div>
        <ul class="list-group list-group-flush bject-info">
          <li class="list-group-item">
            <div class="list-group-icon">
              <svg-map-icon></svg-map-icon>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.address"></translate-component>
              </div>
              <div class="info-list-item">{{ zone_info.info.Address }}</div>
            </div>
          </li>
          <li class="list-group-item" v-if="zone_info.info.phones && zone_info.info.phones.length> 0 ">
            <div class="list-group-icon">
              <svg-phone-icon/>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.phone"></translate-component>
              </div>
              <div class="info-list-item">{{ zone_info.info.phones }}</div>
            </div>
          </li>
          <li class="list-group-item" v-if="zone_info.info.phone && zone_info.info.phone.length> 0 ">
            <div class="list-group-icon">
              <svg-phone-icon/>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.phone"></translate-component>
              </div>
              <div class="info-list-item">{{ zone_info.info.phone }}</div>
            </div>
          </li>
          <li class="list-group-item" v-if="zone_info.info.MyClientName &&  zone_info.info.MyClientName.length >0 ">
            <div class="list-group-icon">
              <svg-client-zone-icon/>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.client"></translate-component>
              </div>
              <div class="info-list-item"><span style="margin-right: 10px" v-if="zone_info.info.MyClientId > 0 ">{{
                  zone_info.info.MyClientId
                }}</span> {{ zone_info.info.MyClientName }}
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="zone_info.info.MyClientName &&  zone_info.info.MyClientName.length >0 ">
            <div class="list-group-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                   id="Capa_1" x="0px" y="0px" viewBox="0 0 386.187 386.187"
                   style="enable-background:new 0 0 386.187 386.187;" xml:space="preserve">
<path
  d="M48.626,131.93c0.418,4.952,4.745,8.635,9.723,8.215c0.327-0.028,0.647-0.072,0.963-0.133  c6.549,36.481,38.521,64.251,76.858,64.251s70.31-27.77,76.858-64.251c0.314,0.061,0.635,0.104,0.961,0.133  c4.965,0.416,9.307-3.261,9.724-8.214l1.171-13.919c0.416-4.953-3.262-9.307-8.214-9.724c-1.532-0.128-3.003,0.134-4.319,0.703  c-3.458-15.338-11.44-28.979-22.469-39.443c-0.032-0.036-0.064-0.071-0.098-0.106c-0.34-0.366-0.703-0.697-1.085-0.993  c-13.88-12.643-32.32-20.358-52.529-20.358c-37.154,0-68.331,26.084-76.181,60.901c-1.315-0.569-2.78-0.83-4.318-0.703  c-4.953,0.417-8.631,4.77-8.215,9.723L48.626,131.93z M136.17,66.09c11.915,0,23.03,3.485,32.381,9.491  c-9.601,6.155-20.789,9.466-32.381,9.466c-5.385,0-10.727-0.713-15.876-2.119c-4.79-1.311-9.743,1.517-11.053,6.313  c-1.309,4.795,1.518,9.743,6.313,11.053c6.693,1.827,13.63,2.754,20.616,2.754c16.78,0,32.907-5.337,46.26-15.176  c8.633,10.406,13.826,23.759,13.826,38.305c0,33.132-26.954,60.087-60.086,60.087s-60.086-26.955-60.086-60.087  S103.039,66.09,136.17,66.09z M144.559,124c0-4.971,4.029-9,9-9h10.001c4.971,0,9,4.029,9,9s-4.029,9-9,9h-10.001  C148.588,133,144.559,128.971,144.559,124z M133.671,151h4.998c4.971,0,9,4.029,9,9s-4.029,9-9,9h-4.998c-4.971,0-9-4.029-9-9  S128.701,151,133.671,151z M100.263,124c0-4.971,4.029-9,9-9h10c4.971,0,9,4.029,9,9s-4.029,9-9,9h-10  C104.292,133,100.263,128.971,100.263,124z M291.887,92.778c0.04,4.971-3.956,9.222-8.927,9.222c-0.025,0-0.05,0-0.075,0  c-4.937,0-8.958-4.13-8.998-9.076c-0.079-9.746,7.034-15.867,12.749-20.666c4.485-3.767,7.426-6.417,7.426-8.842  c0-4.91-3.993-8.904-8.902-8.904c-4.913,0-8.906,3.994-8.906,8.904c0,4.971-4.029,9-9,9s-9-4.029-9-9  c0-14.835,12.068-26.904,26.902-26.904c14.838,0,26.906,12.069,26.906,26.904c0,10.997-8.006,17.719-13.852,22.627  C295.998,87.902,291.876,91.511,291.887,92.778z M260.624,376.292c0.134,1.157,0.039,2.295-0.254,3.372  c-0.241,0.891-0.615,1.717-1.1,2.475c-0.002,0.003-0.004-0.014-0.007-0.01c-1.071,1.676-2.695,2.961-4.69,3.635  c-0.291,0.099-0.587,0.103-0.89,0.171c-0.765,0.176-1.533,0.064-2.278,0.064h-75.252c-4.971,0-9-4.029-9-9s4.029-9,9-9h64.078  l-23.773-97.646c-3.654-15.023-22.957-27.718-43.359-29.327c-6.951,11.05-21.069,18.31-36.688,18.31s-29.736-7.32-36.688-18.37  c-20.402,1.609-39.705,14.374-43.357,29.397L32.591,368h64.076c4.971,0,9,4.029,9,9s-4.029,9-9,9h-75.25  c-0.09,0-0.179,0.164-0.27,0.164c-0.663,0-1.336,0.085-2.01-0.068c-0.304-0.069-0.603-0.152-0.894-0.252  c-1.979-0.67-3.595-1.98-4.665-3.639c-0.508-0.785-0.897-1.65-1.142-2.578c-0.277-1.048-0.369-2.149-0.244-3.272  c0.05-0.466,0.136-0.905,0.254-1.346l26.428-108.676C44.791,241.999,73.396,223,103.997,223h1.237c3.845,0,7.265,2.395,8.513,6.032  c2.119,6.173,10.584,12.376,22.664,12.376s20.545-6.218,22.664-12.391c1.248-3.637,4.668-6.017,8.513-6.017h1.236  c30.6,0,59.205,18.999,65.124,43.332l26.428,108.65C260.49,375.409,260.573,375.843,260.624,376.292z M291.991,118.74  c0,4.971-4.029,9.035-9,9.035s-8.943-3.995-8.943-8.966v-0.069c0-4.971,3.972-9,8.943-9S291.991,113.77,291.991,118.74z   M374.048,39.052v86.867c0,21.275-17.757,39.081-39.032,39.081H251.8l-26.912,35.664c-1.768,2.358-4.472,3.37-7.208,3.37  c-1.879,0-3.773-0.555-5.392-1.769c-3.978-2.981-4.784-8.561-1.803-12.537l29.612-39.375c1.7-2.268,4.368-3.353,7.201-3.353h87.717  c11.35,0,21.032-9.731,21.032-21.081V39.052c0-11.35-9.683-21.052-21.032-21.052h-104.82c-11.351,0-20.585,9.41-20.585,20.759  c0,4.971-4.029,9.175-9,9.175s-9-4.146-9-9.117C191.611,17.542,208.92,0,230.196,0h104.82C356.291,0,374.048,17.776,374.048,39.052z  "/>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
</svg>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.phone"></translate-component>
              </div>
              <div class="info-list-item"><span style="margin-right: 10px" v-if="zone_info.info.phones.MyClientId > 0 ">{{
                  zone_info.info.phones.MyClientId
                }}</span> {{ zone_info.info.phones.MyClientName }}
              </div>
            </div>
          </li>
          <li class="list-group-item" v-else>
            <div class="list-group-icon">
              <svg-client-zone-icon/>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.client"></translate-component>
              </div>
              <div class="info-list-item">
                <translate-component :text="lang.zone_info_component.none_client"></translate-component>
              </div>
            </div>
          </li>

          <li class="list-group-item" v-if="zone_info.info.Comment && zone_info.info.Comment.length > 0 ">
            <div class="list-group-icon">
              <svg-comment-icon/>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.comments"></translate-component>
              </div>
              <div class="info-list-item">{{ zone_info.info.Comment.length }}</div>

            </div>
          </li>

          <li class="list-group-item">
            <div class="list-group-icon">
              <svg-clock-icon></svg-clock-icon>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.time"></translate-component>
              </div>
              <div class="info-list-item" v-if="isNaN(zone_info.info.dt)">{{zone_info.info.dt}}</div>
              <div class="info-list-item" v-else>{{zone_info.info.dt | moment('DD.MM.YYYY HH:mm') }}</div>

            </div>
          </li>
          <li class="list-group-item">
            <div class="list-group-icon">
              <svg-coordinate-icon></svg-coordinate-icon>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.coordinates"></translate-component>
              </div>
              <div class="info-list-item">{{ zone_info.info.y + ', ' + zone_info.info.x }}</div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="list-group-icon">

              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                   id="Capa_1" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;"
                   xml:space="preserve">
<g>
	<path
    d="M56.699,48.02c-0.55-0.104-1.069,0.24-1.18,0.781C54.403,54.303,50.074,58,44.749,58c-5.028,0-9.446-3.3-10.948-8H38.5v-2   h-8v8h2v-3.848C34.669,56.833,39.415,60,44.749,60c6.304,0,11.42-4.341,12.731-10.801C57.59,48.657,57.24,48.13,56.699,48.02z"/>
  <path
    d="M56.5,36v4.308C54.25,35.855,49.796,33,44.749,33c-6.109,0-11.541,3.997-13.209,9.721c-0.154,0.53,0.15,1.085,0.681,1.239   c0.529,0.154,1.085-0.15,1.239-0.681C34.858,38.482,39.605,35,44.749,35c4.565,0,8.562,2.766,10.33,7H50.5v2h8v-8H56.5z"/>
  <path
    d="M37.5,32h9V21h-9h-2h-7h-2h-7h-2h-9v9v2v7v2v9h9h2h9v-9v-2v-7h7H37.5z M37.5,23h7v7h-7V23z M19.5,23h7v7h-7V23z M10.5,23h7   v7h-7V23z M10.5,32h7v7h-7V32z M17.5,48h-7v-7h7V48z M26.5,48h-7v-7h7V48z M26.5,39h-7v-7h7V39z M28.5,30v-7h7v7H28.5z"/>
  <path
    d="M25.5,55h-22V16h48v13c0,0.553,0.447,1,1,1s1-0.447,1-1V15V5c0-0.553-0.447-1-1-1h-5V1c0-0.553-0.447-1-1-1h-7   c-0.553,0-1,0.447-1,1v3h-22V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3h-5c-0.553,0-1,0.447-1,1v10v41c0,0.553,0.447,1,1,1   h23c0.553,0,1-0.447,1-1S26.053,55,25.5,55z M40.5,2h5v3v3h-5V5V2z M9.5,2h5v3v3h-5V5V2z M3.5,6h4v3c0,0.553,0.447,1,1,1h7   c0.553,0,1-0.447,1-1V6h22v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h4v8h-48V6z"/>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
</svg>

            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.desired_time"></translate-component>
                <span
                  style="margin-left: 5px"> {{ checkDataNumber(zone_info.info.StopFromHH) }}:{{ checkDataNumber(zone_info.info.StopFromMM) }} - {{
                    checkDataNumber(zone_info.info.StopToHH)
                  }}:{{ checkDataNumber(zone_info.info.StopToMM) }}</span>
              </div>
              <div class="info-list-item">
                <translate-component :text="lang.zone_info_component.periodicity"></translate-component>


                <span style="margin-left: 5px">:
                <span v-if="zone_info.info.bWeekDays > 0 ">
                  <translate-component :text="lang.zone_info_component.every_week"></translate-component>
                </span>
                  <span v-else>
                    <translate-component :text="lang.zone_info_component.every_month"></translate-component>
                  </span>
              </span>
              </div>
            </div>
          </li>

          <li class="list-group-item" v-if="zone_info.info.RouteLists && zone_info.info.RouteLists.length> 0 ">
            <div class="list-group-icon">
              <svg-route-zone-icone/>
            </div>
            <div>
              <div class="info-list-title">
                <translate-component :text="lang.zone_info_component.route_list"></translate-component>
                <span style="margin-left: 5px;">{{ zone_info.info.RouteLists.length }}</span>
              </div>
              <div class="info-list-item">
                <p class="info-list-routes" v-for="(route,index) in zone_info.info.RouteLists">
                  <span class="info-list-item-1">{{ index + 1 }}</span> <span
                  class="info-list-item-2">{{ route.Name }}</span> <span
                  class="info-list-item-3">{{ route.Number }}</span>
                </p>

              </div>
            </div>
          </li>

          <div style="display:none;">{{monitor_counter}}</div>
          <li class="list-group-item" v-if="zone_info.monitoring  &&  zone_info.monitoring_start_time">
            <div class="list-group-icon">
              <svg-monitoring-car-icon/>
            </div>
            <div style="width: 100%">
              <div class="info-list-title monitoring">
                <div class="info-list-top monitoring"><div style="display:none;">{{monitor_counter}}</div>
                  <translate-component :text="lang.zone_info_component.monitorin_enter_list"></translate-component>
                  <span class="info-list-count ">{{ Object.keys(this.zone_info.monitoring).length }}</span>
                  <span class="info-list-count-now">
                  <translate-component :text="lang.zone_info_component.monitorin_enter_now" />
                  {{ getInsideNow() }}
                </span>
                  <span class="fa  monitoring" :class="show_enter ? 'fa-chevron-up' : 'fa-chevron-down'"
                        @click="show_enter = !show_enter"></span>
                </div>
                <div class="info-list-top monitoring">
                  <span class="info-list-start" v-if="zone_info.monitoring_start_time">
                   start: {{ zone_info.monitoring_start_time | moment("DD.MM HH:mm") }}
                  </span>
                  <span class="info-list-end" v-if="zone_info.monitoring_stop_time">
                   end: {{ zone_info.monitoring_stop_time | moment("DD.MM HH:mm") }}
                  </span>
                </div>

              </div>
              <perfect-scrollbar>
                <div class="info-list-item " v-if="show_enter">
                  <div class="info-list-monitoring " v-for="(item,key,index) in zone_info.monitoring">
                    <p class="info-list-routes-data">
                      <span class="info-list-item-1">{{ index + 1 }}</span> <span
                      class="info-list-item-2">{{ item[0].Number }}</span> <span class="info-list-item-3"
                                                                                 v-if="item[0].Driver_name">{{ item[0].Driver_name }}</span>
                      <span class="info-list-routes-time">EN: {{ item[0].enter_time | moment("DD.MM h:mm") }}</span>
                      <span class="info-list-routes-out"
                            v-if="item[0].out_time">OUT: {{ item[0].out_time | moment("DD.MM h:mm") }}</span>
                    </p>
                    <p class="info-list-routes-data" v-if="item[0].hidtory">
                      <span class="info-list-item-2"><translate-component :text="lang.zone_info_component.zone_history"/>: </span>
                      <template v-for="elem in item[0].hidtory">
                        <span class="info-list-routes-time">EN: {{ elem.enter_time | moment("DD.MM h:mm") }}</span>
                        <span class="info-list-routes-out"
                              v-if="elem.out_time">OUT: {{ elem.out_time | moment("DD.MM h:mm") }}</span>
                      </template>
                    </p>


                  </div>
                </div>
              </perfect-scrollbar>
            </div>
          </li>


        </ul>
        <div class="card-body bject-info">

        </div>
      </template>
    </div>
  </section>

</template>

<script>
import {mapGetters} from "vuex";
import helpers from "@/mixins/helpers";
import mapHelper from "@/mixins/mapHelper";
import TranslateComponent from "@/components/dashboard/TranslateComponent";
import moment from "moment";
import SvgMapIcon from "@/components/ui/icons/svgMapIcon";
import SvgClockIcon from "@/components/ui/icons/svgClockIcon";
import SvgCoordinateIcon from "@/components/ui/icons/svgCoordinateIcon";
import SvgClickIcon from "@/components/ui/icons/svgClickIcon";
import SvgPhoneIcon from "@/components/ui/icons/svgPhoneIcon";
import SvgClientZoneIcon from "@/components/ui/icons/svgClientZoneIcon";
import SvgCommentIcon from "@/components/ui/icons/svgCommentIcon";
import SvgMonitoringCarIcon from "@/components/ui/icons/svgMonitoringCarIcon";
import SvgRouteZoneIcone from "@/components/ui/icons/svgRouteZoneIcone";

var momentDurationFormatSetup = require("moment-duration-format");
momentDurationFormatSetup(moment);
typeof moment.duration.fn.format === "function";
// true
typeof moment.duration.format === "function";
// true
export default {
  name: "ZoneInfoComponent",
  components: {
    SvgRouteZoneIcone,
    SvgMonitoringCarIcon,
    SvgCommentIcon,
    SvgClientZoneIcon,
    SvgPhoneIcon, SvgClickIcon, SvgCoordinateIcon, SvgClockIcon, SvgMapIcon, TranslateComponent
  },
  mixins: [helpers, mapHelper],
  data() {
    return {
      monitor_counter:0,
      base_url: base_url,
      backgroundImageUrl: '/tracking/assets/images/geo-zone/viljnjus_image.jpg',
      show_enter: false,
      show_out: false,
      timer: null,
      set_time:1000,
      loading_test:0,
    }
  },
  computed: {
    ...mapGetters({
      zone_info: 'ZONE_INFO',
      show_zone_info: 'SHOW_ZONE_INFO',
      lang: 'LANG',
    }),
  },
  mounted() {
    this.getNewTimer()
  },
  methods: {
    getNewTimer() {
      this.timer = setInterval(() => {
            this.monitor_counter++
          },
          this.set_time);
    },
    getInsideNow() {
      let count = 0
      let _this = this;
      Object.keys(this.zone_info.monitoring).forEach(function (key) {

        if (_this.zone_info.monitoring[key][0].out_time === false) {
          count++
        }
      });
        return count
    },
    checkDataNumber(num) {
      if (num < 10) {
        return '0' + num
      }
      return num
    },
    getDuration(add_duration) {
      let add = moment.duration(add_duration, "seconds").format("d[d] h:mm:ss");

      return add
    },
    closeInfo() {
      this.$store.commit('SET_SHOW_ZONE_INFO', false);
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  }


}
</script>


<style scoped>
.card.object-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 300px;
  max-width: 350px;
  height: auto;
  max-height: calc(100% - 80px);
  position: fixed;
  background-color: #fff;
  padding: 0;
  margin: 0;
  top: 60px;
  border-radius: 4px;
  box-shadow: rgb(99 99 99 / 20%) 0px 2px 8px 0px;
}

.widgets-panel__header {
  position: relative;
  height: 180px;
  padding: 0;
  margin: 0;
}

.widgets-panel__tracker-title {
  color: #fff !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  width: 100%;
  z-index: 2;
  font-size: 20px;
  font-weight: bolder;
  text-shadow: 1px 1px #000;
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(transparent));
  background: linear-gradient(rgba(0, 0, 0, 0.5), transparent);

}

.street-view__streetview, .street-view__streetview img {
  border-radius: 4px 4px 0px 0px;
  background-size: cover;
  -webkit-filter: blur(2px);
  filter: blur(2px);
  width: 100%;
  height: 110px;
  background-repeat: no-repeat;
}

.street-view__click-stub {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  cursor: pointer;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.widgets-panel .widgets-panel__street-view {
  height: 110px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.list-group-item {
  border-radius: 0;
}
.widgets-panel__street-view, .widgets-panel__tracker-title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 8px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.widgets-panel__tracker-title{
  padding-right: 30px;
}
.object-info-close {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  justify-content: center;
  padding: 0;
  font-size: 20px;
  color: #ccc;
  width: 30px;
  height: 30px;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  align-items: center;
}

.object-info-close:hover, .object-info-close:focus {
  color: #ffff
}

.list-group-icon {
  width: 25px;
  height: 25px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 5px;
}

.list-group-icon svg {
  fill: #4cabdb;
}

.list-group-item {
  display: flex;
}

.info-list-item {
  font-weight: 600;
  line-height: 18px;
  color: #34495e;
}

.info-list-title {
  line-height: 18px;
  display: flex;
}

.info-list-item_label {
  border: 1px solid #4cabdb;
  padding: 2px 10px;
  border-radius: 15px;
  margin-left: 5px;
}

.card-body.bject-info {
  padding: 20px 20px;
  padding-top: 0;
}

.list-group-item {
  padding: 8px 15px;
}

.info-list-item-2 {
  padding: 0 5px;
}

.fa.monitoring {
  margin-left: auto;
  margin-right: 30px;
}

.info-list-title.monitoring {
  width: 100%;
  padding-bottom: 0;
  display: flex;
  flex-wrap: wrap;
}

.info-list-top.monitoring {
  width: 100%;
  display: flex;
}

.info-list-start {
  font-weight: 600;
  color: #00C853;
  width: 50%;
}

.info-list-end {
  font-weight: 600;
  color: #9E9E9E;
  width: 50%;
}

.info-list-monitoring .info-list-routes-data {
  margin: 0 0 6px;
  font-size: 11px;
}

.info-list-monitoring .info-list-routes-time {
  color: #00C853;
}

.info-list-count {
  margin-left: 5px;
  border: 0.5px solid #4cabdb;
  bordr-color: #4cabdb;
  padding: 2px 9px;
  border-radius: 3px;
  font-weight: 600;
  background: #4cabdb;
  color: #fff;
  line-height: 10px;
  max-height: 20px;
}

.info-list-title.monitoring {
  align-items: center;
  padding-bottom: 15px;
}

.info-list-item {
  max-height: 160px;
}

.info-list-routes-out {
  color: #D50000;
  padding-left: 5px;
}

.info-list-count-now {
  margin-left: 5px;
  border: 0.5px solid #00C853;
  background-color: #00C853;
  color: #fff;
  padding: 2px 5px;
  border-radius: 3px;
  line-height: 10px;
  font-weight: 600;
  max-height: 20px;
  min-width: 70px;
}

.widgets-panel__tracker-group {
  margin-left: auto;
  border-radius: 3px;
  background: #26A69A;
  color: #fff;
  padding: 2px 6px;
  font-size: 14px;
  line-height: 15px;
  font-weight: 600;
  position: absolute;
  bottom: 10px;
  z-index: 1000;
  left: 10px;
}
.street-view__click-stub span{
  opacity:0
}
@media only screen and (max-width: 1500px) {
  .card.object-info {
    min-width: 300px;
    max-width: 320px;
  }
  .widgets-panel__header{
    height: 110px;
  }
  .street-view__streetview, .street-view__streetview img {
    height: 110px;
  }
  .list-group-item{
    padding: 5px 8px;
  }
  .list-group-icon {
    width: 20px;
    min-width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 600px) {
  .object-info-box {
    right: 0;
    padding: 0;
    margin: 0;
    bottom: 0;
    max-width: 100vw;
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 100000;
    top: 60px;
    left: 0px;
  }

  .card.object-info {
    min-width: 100vw;
    max-width: 100vw;
    height: 100%;
    max-height: calc(100% - 60px);
  }
}
</style>
